import Vue from 'vue'
import BodyFatIndex from './BodyFatIndex.vue'
import BodyMassIndex from './BodyMassIndex.vue'
import CaloriesBurn from './CaloriesBurn.vue'
import CaloriesDemand from './CaloriesDemand.vue'
import MaximumWeight from './MaximumWeight.vue'
import BodyFatIndexEn from './BodyFatIndexEn.vue'
import BodyMassIndexEn from './BodyMassIndexEn.vue'
import CaloriesBurnEn from './CaloriesBurnEn.vue'
import CaloriesDemandEn from './CaloriesDemandEn.vue'
import MaximumWeightEn from './MaximumWeightEn.vue'

Vue.config.productionTip = true

new Vue({
  render: h => h(BodyFatIndex),
}).$mount('#bodyFatIndex')

new Vue({
  render: h => h(BodyFatIndexEn),
}).$mount('#bodyFatIndexEn')

new Vue({
  render: h => h(BodyMassIndex),
}).$mount('#bodyMassIndex')

new Vue({
  render: h => h(BodyMassIndexEn),
}).$mount('#bodyMassIndexEn')

new Vue({
  render: h => h(CaloriesBurn),
}).$mount('#caloriesBurn')

new Vue({
  render: h => h(CaloriesBurnEn),
}).$mount('#caloriesBurnEn')

new Vue({
  render: h => h(CaloriesDemand),
}).$mount('#caloriesDemand')

new Vue({
  render: h => h(CaloriesDemandEn),
}).$mount('#caloriesDemandEn')

new Vue({
  render: h => h(MaximumWeight),
}).$mount('#maximumWeight')

new Vue({
  render: h => h(MaximumWeightEn),
}).$mount('#maximumWeightEn')